<p-checkbox [binary]="true" class="selectAllCkbox" [(ngModel)]="allSelected" [disabled]="disabled"
    (onChange)="onToggleSelectAll($event)">
</p-checkbox>